var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1151_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.51471C5.78119 1.24823 8.79474 0 12 0C15.2054 0 18.2188 1.24823 20.4853 3.51471C22.7518 5.78119 24 8.79456 24 12C24 15.2053 22.7518 18.2188 20.4853 20.4853C18.2188 22.7518 15.2054 24 12 24C8.79474 24 5.78119 22.7518 3.51471 20.4853C1.24823 18.2188 0 15.2053 0 12C0 8.79456 1.24823 5.78119 3.51471 3.51471ZM17.9841 20.7369C17.4822 17.8471 14.978 15.7156 12 15.7156C9.02179 15.7156 6.51782 17.8471 6.01593 20.7369C7.71973 21.9075 9.78113 22.5938 12 22.5938C14.2189 22.5938 16.2803 21.9075 17.9841 20.7369ZM15.8156 10.4938C15.8156 8.38971 14.1039 6.67822 12 6.67822C9.89612 6.67822 8.18445 8.38989 8.18445 10.4938C8.18445 12.5977 9.89612 14.3093 12 14.3093C14.1039 14.3093 15.8156 12.5977 15.8156 10.4938ZM4.79791 19.7615C5.17639 18.4162 5.92804 17.1956 6.98163 16.2422C7.62799 15.6572 8.36371 15.1956 9.15472 14.8702C7.72504 13.9376 6.77802 12.3243 6.77802 10.4938C6.77802 7.61444 9.12067 5.27197 12 5.27197C14.8793 5.27197 17.2218 7.61444 17.2218 10.4938C17.2218 12.3243 16.2748 13.9376 14.8453 14.8702C15.6361 15.1956 16.372 15.657 17.0184 16.242C18.0718 17.1954 18.8236 18.416 19.2021 19.7613C21.2867 17.8253 22.5938 15.0626 22.5938 12C22.5938 6.15857 17.8414 1.40625 12 1.40625C6.15857 1.40625 1.40625 6.15857 1.40625 12C1.40625 15.0628 2.71326 17.8255 4.79791 19.7615Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1151_509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "matrix(-1 0 0 1 24 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.20002b6866a1d85b20bd593fd41e1f7f.svg";
export { ForwardRef as ReactComponent };